
export const qLogo = require('./logo.png');
export const heroLogo = require('./hero.png');